<template>
    
  <div>

    <page-padding>
      <spinner v-if="showLoader && !hasAlbums" class="spinner-custom" />
       <div v-if="!showLoader && !hasAlbums">{{$t('language.no_albums')}}</div>

      <div v-if="hasAlbums">
        <div>
          <div class="featured_margin-bottom" v-for='(item,index) in sliceArray(albums["0album"],3)' :key="index" @click="viewAlbum(item.id)">
            <featured-album-item type="album" :title="item.title" :text="createIntroText(item.content)" :image_src="item.thumb_medium"/>
          </div>
        </div>
        <button-more title="language.view_more_albums" to="/albums"/>
      </div>
      </page-padding>


  </div>
</template>

<script>

import { mapState } from 'vuex';
import PagePadding from '../PagePadding.vue';
import Spinner from '../Spinner.vue';
import FeaturedAlbumItem from './FeaturedAlbumItem.vue';
import ButtonMore from '../buttons/ButtonMore.vue';
import { helper } from '../../services/Helper.js';
   

export default {
  name: 'list-albums-featured',
  props:{
  },
  data:function(){
    return {
      showLoader:false,
    }
  },
  components:{
    PagePadding,
    Spinner,
    FeaturedAlbumItem,
    ButtonMore,
  },
  methods:{
    sliceArray(arr,count){
      if(arr){
        return arr.slice(0,count)
      }else{
        return [];
      }
    },
     viewAlbum(id){
      this.$router.push({path:'/photoalbum/'+id+'/view'});
    },
    createIntroText(txt){
      return helper.getExcerpt(txt);
    }
  },
  computed:{
    ...mapState([
       'albums',
       ]),
       hasAlbums:function(){
         if(this.albums["0album"]){
           return this.albums["0album"] ? this.albums["0album"].length : 0;
         }else{
           return false;
         }
       },
       
  },
  created:function(){
    this.showLoader=true;
    this.$store.dispatch('get_albums',{store_key:"0album"}).then(()=>{
      this.showLoader=false;
    })
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.featured_margin-bottom{
  
  padding:25px 0;
  border-bottom: 1px solid #DDDDDD;
}

.featured_margin-bottom:first-child{
  border-top: 1px solid #DDDDDD;
  margin-top:15px;
}

.featured_margin-bottom:last-child{
  margin-bottom:15px;
}


.spinner-custom{
  margin:10px 0;
}
</style>

